<template>
    <div class="modal">
        <div class="head">Вы действительно хотите удалить здание?</div>
        <div class="buttons">
            <button @click="deleteHouse">Удалить</button>
            <div @click="$store.commit('changeShowModal', 'DeleteHouse')" class="cancel">Отмена</div>
        </div>

        <div @click="$store.commit('changeShowModal', 'DeleteHouse')" class="close">
            <img src="@/assets/img/close.svg" alt="">
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        async deleteHouse() {
            let r = await this.$store.dispatch("request", {
                method: "delete",
                path: `/adm/buildings/${this.$store.getters.houseForDelete}`
            })
            if (r.status == 200) {
                this.$store.commit("changeShowModal", "DeleteHouse")
                this.$store.commit("setActiveHouse", null)
                this.$store.dispatch("loadData")
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.modal {
    .head {
        font-size: 20px;
        line-height: 30px;
    }
}
</style>